import React from "react";

type CircularImageRowProps = {
  images: { src: string; alt: string }[];
};

export default function CircularImageRow({ images }: CircularImageRowProps) {
  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        justifyContent: "center",
        margin: "24px 0",
        flexWrap: "wrap",
      }}
    >
      {images.map((img, idx) => (
        <img
          key={idx}
          src={img.src}
          alt={img.alt}
          style={{
            width: 80,
            height: 80,
            objectFit: "cover",
            borderRadius: "50%",
            border: "3px solid rgba(168, 111, 214, 0.4)",
            boxShadow: "0 4px 16px rgba(168, 111, 214, 0.2)",
            transition: "all 0.3s ease",
            cursor: "pointer"
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.border = "3px solid rgba(168, 111, 214, 0.8)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.border = "3px solid rgba(168, 111, 214, 0.4)";
          }}
        />
      ))}
    </div>
  );
}
